import { arrawDown, dashboard, menu, globeIcon, setting } from "../assets/Icons/icons";
import { adminLogo, profile } from "../assets/img/image";
import { strings } from "../strings/strings";

import DashboardLayout from "./DashboardLayout";

const superAdminMenu = [
  {
    title: strings.countrydata,
    icon: <img src={globeIcon} className="w-5 h-5" alt="" />,
    path: "/superadmin/country-data",
  },
  {
    title: strings.countryadmin,
    icon: <img src={dashboard} className="w-5 h-5" alt="" />,
    path: "/superadmin/country-admin",
  },
  {
    title: strings.settings,
    icon: <img src={setting} className="w-5 h-5 opacity-85" alt="" />,
    path: "/superadmin/settings",
  },
];

const SuperAdminLayout = () => {
  return (
    <DashboardLayout
      menuItems={superAdminMenu}
      logo={{ main: adminLogo, menu, dropdown: arrawDown }}
      profileImg={profile}
      roleName={strings.superadmin}
    />
  );
};

export default SuperAdminLayout;
